import React, { useEffect } from "react";
import "./registrationconfirm.css";
import { IMAGE_PATH } from "../../../Utils/variables";

const RegistrationConfirm = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className="successDetailsMainContainer"
      style={{
        backgroundImage: `url(${IMAGE_PATH}loginLeftBg.svg),url(${IMAGE_PATH}successRightBg.svg)`,
      }}
    >
      <div className="supersuccessDetailsMainDiv">
        <div className="successDetailsHeading">SUCCESS!</div>
        <div className="successDetailsMainDiv">
          <label className="successFormSubHeading">
            {JSON.parse(localStorage.getItem("success_msg")) &&
              JSON.parse(localStorage.getItem("success_msg"))}
          </label>
          <div>
            <label htmlFor=""></label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationConfirm;
